/**
 *
 * File created by DI Michael Pittner
 *
 * Project: eve
 * Date: 02/02/2026
 * Time: 13:07
 *
 */

(function () {
    function getCurrentPageViewId() {
        const meta = document.querySelector('meta[name="eve-page-view-id"]');
        return window.__EVE_PAGE_VIEW_ID || meta?.getAttribute("content") || "";
    }

    function setCurrentPageViewId(id) {
        window.__EVE_PAGE_VIEW_ID = id;
        const meta = document.querySelector('meta[name="eve-page-view-id"]');
        if (meta) {
            meta.setAttribute("content", id);
        }
    }

    function generatePageViewId() {
        if (window.crypto && typeof window.crypto.randomUUID === "function") {
            return window.crypto.randomUUID().replace(/-/g, "");
        }
        return String(Date.now()) + Math.random().toString(16).slice(2);
    }

    function getCurrentPath() {
        return location.pathname + location.search;
    }

    const initialPageViewId = getCurrentPageViewId();
    if (!initialPageViewId) return;

    setCurrentPageViewId(initialPageViewId);

    // --- fetch patch ---
    const _fetch = window.fetch;
    window.fetch = function (input, init) {
        init = init || {};
        const headers = new window.Headers(init.headers || {});
        const currentPageViewId = getCurrentPageViewId();

        if (currentPageViewId && !headers.has("X-Page-View-Id")) {
            headers.set("X-Page-View-Id", currentPageViewId);
        }

        init.headers = headers;
        return _fetch(input, init);
    };

    // --- XHR patch ---
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function () {
        this.__evePageViewId = getCurrentPageViewId();
        return _open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
        try {
            if (this.__evePageViewId) {
                this.setRequestHeader("X-Page-View-Id", this.__evePageViewId);
            }
        } catch (e) {}
        return _send.apply(this, arguments);
    };

    function sendVirtualNavigationMetrics(trigger) {
        const currentPageViewId = getCurrentPageViewId();
        if (!currentPageViewId) return;

        const send = (event) => {
            const url = '/ajax/telemetry/metrics';
            const body = JSON.stringify(event);
            const blob = new Blob([body], { type: 'application/json' });

            if (navigator.sendBeacon) {
                navigator.sendBeacon(url, blob);
            } else {
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Page-View-Id': currentPageViewId
                    },
                    body,
                    keepalive: true
                }).catch(() => {});
            }
        };

        const baseEvent = {
            occurred_at: new Date().toISOString(),
            page_view_id: currentPageViewId,
            path: getCurrentPath(),
            referrer: document.referrer || null,
            ua_raw: navigator.userAgent || null,
            lang: navigator.language || null,
            nav_mode: 'soft',
            nav_trigger: trigger
        };

        send({
            ...baseEvent,
            event_type: 'page_view'
        });

        // 2️⃣ PageNav minimal verzögert (Reihenfolge safe)
        setTimeout(() => {
            send({
                ...baseEvent,
                event_type: 'page_nav',
                ttfb_ms_cli: null,
                duration_ms_cli: null,
                dcl_ms_cli: null,
                load_ms_cli: null,
                interactive_ms_cli: null,
                fp_ms: null,
                fcp_ms: null,
                bytes_in_cli: null
            });
        }, 10);
    }

    let lastUrl = location.pathname + location.search + location.hash;

    function handleVirtualNavigation(trigger) {
        const nextUrl = location.pathname + location.search + location.hash;
        if (nextUrl === lastUrl) return;

        try {
            window.dispatchEvent(new CustomEvent('eve:before-pageview-change', {
                detail: {
                    old_page_view_id: getCurrentPageViewId(),
                    next_path: nextUrl,
                    trigger
                }
            }));
        } catch (e) {}

        lastUrl = nextUrl;

        const newPageViewId = generatePageViewId();
        setCurrentPageViewId(newPageViewId);

        sendVirtualNavigationMetrics(trigger);

        try {
            window.__telemetrySendResourceSummary && window.__telemetrySendResourceSummary();
        } catch (e) {}

        try {
            window.dispatchEvent(new CustomEvent('eve:pageview-changed', {
                detail: {
                    page_view_id: newPageViewId,
                    path: getCurrentPath(),
                    trigger
                }
            }));
        } catch (e) {}
    }

    const _pushState = history.pushState;
    history.pushState = function () {
        const result = _pushState.apply(this, arguments);
        handleVirtualNavigation('pushState');
        return result;
    };

    const _replaceState = history.replaceState;
    history.replaceState = function () {
        const result = _replaceState.apply(this, arguments);
        handleVirtualNavigation('replaceState');
        return result;
    };

    window.addEventListener('popstate', function () {
        handleVirtualNavigation('popstate');
    });

    window.__EVE_GET_CURRENT_PAGE_VIEW_ID = getCurrentPageViewId;
    window.__EVE_SET_CURRENT_PAGE_VIEW_ID = setCurrentPageViewId;
})();

/* Error fetcher JS */
(function () {
    /* START - CONSOLE FETCHER */
    const consoleBuffer = [];
    const MAX_LOGS = 100;

    ["log", "warn", "error", "info", "debug"].forEach(level => {
        const orig = console[level];

        console[level] = function (...args) {
            try {
                consoleBuffer.push({
                    ts: Date.now(),
                    level,
                    msg: args.map(a =>
                        typeof a === "string" ? a : JSON.stringify(a)
                    ).join(" ")
                });

                if (consoleBuffer.length > MAX_LOGS) {
                    consoleBuffer.shift();
                }
            } catch (e) {}

            orig.apply(console, args);
        };
    });
    /* END - CONSOLE FETCHER */

    function getPageViewId() {
        if (typeof window.__EVE_GET_CURRENT_PAGE_VIEW_ID === 'function') {
            return window.__EVE_GET_CURRENT_PAGE_VIEW_ID();
        }
        const meta = document.querySelector('meta[name="eve-page-view-id"]');
        return meta?.getAttribute("content") || "";
    }

    if (!getPageViewId()) return;

    const send = (payload) => {
        try {
            const effectivePageViewId = getPageViewId() || "missing";
            const body = JSON.stringify(payload);

            if (navigator.sendBeacon) {
                navigator.sendBeacon("/ajax/telemetry/browser-error", new Blob([body], { type: "application/json" }));
                return;
            }

            fetch("/ajax/telemetry/browser-error", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Page-View-Id": effectivePageViewId
                },
                body,
                keepalive: true
            }).catch(() => {});
        } catch (e) {}
    };

    const seen = new Map();

    const shouldSend = (key) => {
        const now = Date.now();
        const last = seen.get(key) || 0;
        if (now - last < 10000) return false;
        seen.set(key, now);
        return true;
    };

    const base = () => ({
        event_type: "js_error",
        occurred_at: new Date().toISOString(),
        page_view_id: getPageViewId() || "missing",
        path: location.pathname + location.search,
        referrer: document.referrer || null,
        ua_raw: navigator.userAgent || null,
        lang: navigator.language || null
    });

    window.addEventListener("error", (e) => {
        const msg = (e?.message || "unknown").toString().slice(0, 500);
        const stack = (e?.error?.stack ? String(e.error.stack) : "").slice(0, 4000) || null;

        const key = "error|" + msg + "|" + (stack ? stack.slice(0, 200) : "");
        if (!shouldSend(key)) return;

        send({
            ...base(),
            event_type: "js_error",
            error_class: "JS-Error",
            message: msg,
            stack: stack,
            console_json: consoleBuffer.slice(-50),
            source: e?.filename || null,
            line: e?.lineno || null,
            column: e?.colno || null,
        });

        try {
            window.__telemetrySendResourceDebug && window.__telemetrySendResourceDebug();
        } catch (e) {}
    });

    window.addEventListener("unhandledrejection", (e) => {
        const reason = e?.reason;
        const msg = (reason?.message ? String(reason.message) : String(reason || "unknown")).slice(0, 500);
        const stack = (reason?.stack ? String(reason.stack) : "").slice(0, 4000) || null;

        const key = "rej|" + msg + "|" + (stack ? stack.slice(0, 200) : "");
        if (!shouldSend(key)) return;

        send({
            ...base(),
            event_type: "Unhandled_rejection",
            error_class: "Unh.Rec.",
            message: msg,
            stack: stack,
            console_json: consoleBuffer.slice(-50),
            source: e?.filename || null,
            line: e?.lineno || null,
            column: e?.colno || null,
        });

        try {
            window.__telemetrySendResourceDebug && window.__telemetrySendResourceDebug();
        } catch (e) {}
    });

    window.addEventListener("error", (e) => {
        const t = e.target;
        const url = t?.src || t?.href;
        if (url && !e.error) {
            send({
                ...base(),
                event_type: "resource_error",
                error_class: "ResErr",
                message: "resource load failed",
                items: [{
                    url,
                    tag: (t.tagName || "").toLowerCase(),
                    rel: t.rel || null,
                    as_type: t.as || null
                }]
            });
        }
    }, true);

    window.addEventListener("securitypolicyviolation", (e) => {
        send({
            ...base(),
            event_type: "csp_violation",
            error_class: "CSP-Vio",
            message: e.violatedDirective || "csp_violation",
            effective_directive: e.effectiveDirective || null,
            blocked_uri: e.blockedURI || null,
            source_file: e.sourceFile || null,
            line: e.lineNumber || null,
            column: e.columnNumber || null,
            disposition: e.disposition || null,
            status_code: e.statusCode || null,
        });
    });
})();

window.simulateTelemetryError = function () {
    function a(){ b(); }
    function b(){ c(); }
    function c(){ throw new Error("Telemetry Deep Test"); }
    setTimeout(a, 0);
};

/* Collect and send TTFB to Server */
(function () {
    function navMetrics() {
        const nav = window.performance.getEntriesByType('navigation')[0];
        if (!nav) return null;

        const ttfb = Math.round(nav.responseStart);
        const total = Math.round(nav.duration);
        const domContentLoaded = Math.round(nav.domContentLoadedEventEnd);
        const load = Math.round(nav.loadEventEnd);
        const domInteractive = Math.round(nav.domInteractive);
        const bytesIn = (typeof nav.transferSize === 'number') ? nav.transferSize : null;

        return {
            ttfb_ms: ttfb,
            total_ms: total,
            dcl_ms: domContentLoaded,
            load_ms: load,
            interactive_ms: domInteractive,
            bytes_in: bytesIn
        };
    }

    function firstPaintMetrics() {
        const paints = window.performance.getEntriesByType('paint');
        const fp = paints.find(p => p.name === 'first-paint');
        const fcp = paints.find(p => p.name === 'first-contentful-paint');
        return {
            fp_ms: fp ? Math.round(fp.startTime) : null,
            fcp_ms: fcp ? Math.round(fcp.startTime) : null,
        };
    }

    function getPageViewId() {
        if (typeof window.__EVE_GET_CURRENT_PAGE_VIEW_ID === 'function') {
            return window.__EVE_GET_CURRENT_PAGE_VIEW_ID();
        }
        const meta = document.querySelector('meta[name="eve-page-view-id"]');
        return meta?.getAttribute("content") || null;
    }

    function send(event) {
        const url = '/ajax/telemetry/metrics';
        const blob = new Blob([JSON.stringify(event)], { type: 'application/json' });

        if (navigator.sendBeacon) {
            navigator.sendBeacon(url, blob);
        } else {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(event),
                keepalive: true
            }).catch(() => {});
        }
    }

    function safeUrl(u) {
        try { return String(u || "").slice(0, 2000); } catch(e){ return ""; }
    }

    function summarizeResources(mode) {
        const list = performance.getEntriesByType("resource") || [];
        const pageHost = location.host || "";

        let totalCount = 0;
        let totalTransfer = 0;
        let totalEncoded = 0;
        let totalDecoded = 0;

        const byInitiator = {};
        const thirdParty = { count: 0, transfer: 0 };

        const rows = [];
        for (const r of list) {
            const name = safeUrl(r.name);
            if (!name) continue;

            const initiator = String(r.initiatorType || "other");
            const startMs = Math.round(r.startTime || 0);
            const durationMs = Math.round(r.duration || 0);

            const transfer = (typeof r.transferSize === "number") ? Math.max(0, Math.round(r.transferSize)) : 0;
            const enc = (typeof r.encodedBodySize === "number") ? Math.max(0, Math.round(r.encodedBodySize)) : 0;
            const dec = (typeof r.decodedBodySize === "number") ? Math.max(0, Math.round(r.decodedBodySize)) : 0;

            totalCount++;
            totalTransfer += transfer;
            totalEncoded += enc;
            totalDecoded += dec;

            byInitiator[initiator] = byInitiator[initiator] || { count: 0, transfer: 0 };
            byInitiator[initiator].count++;
            byInitiator[initiator].transfer += transfer;

            let host = "";
            let path = name;
            try {
                if (/^https?:\/\//i.test(name)) {
                    const u = new URL(name);
                    host = u.host || "";
                    path = (u.pathname || "/") + (u.search || "");
                }
            } catch(e) {}

            const isThird = (host && pageHost && host.toLowerCase() !== pageHost.toLowerCase());
            if (isThird) {
                thirdParty.count++;
                thirdParty.transfer += transfer;
            }

            rows.push({
                name,
                initiator_type: initiator,
                start_ms: startMs,
                duration_ms: durationMs,
                transfer_size: transfer,
                encoded_size: enc,
                decoded_size: dec,
                protocol: (typeof r.nextHopProtocol === "string") ? r.nextHopProtocol : "",
                host,
                path,
                is_third_party: isThird ? 1 : 0,
                is_large: transfer >= 200000 ? 1 : 0,
                is_slow: durationMs >= 1500 ? 1 : 0
            });
        }

        const cap = (mode === "error_debug") ? 80 : 30;

        const slow = rows.slice().sort((a,b)=> b.duration_ms - a.duration_ms).slice(0, Math.min(20, cap));
        const large = rows.slice().sort((a,b)=> b.transfer_size - a.transfer_size).slice(0, Math.min(20, cap));

        let extra = [];
        if (mode === "error_debug") {
            const critical = rows.filter(x => ["script","css","font"].includes(x.initiator_type));
            const seen = new Set();
            extra = critical.filter(x => (seen.has(x.name) ? false : (seen.add(x.name), true))).slice(0, 40);
        }

        const pick = [];
        const seen = new Set();

        function add(arr) {
            for (const x of arr) {
                if (pick.length >= cap) break;
                if (seen.has(x.name)) continue;
                seen.add(x.name);
                pick.push(x);
            }
        }

        add(slow);
        add(large);
        add(extra);

        return {
            totals: {
                count: totalCount,
                transfer_size: totalTransfer,
                encoded_size: totalEncoded,
                decoded_size: totalDecoded,
                third_party_count: thirdParty.count,
                third_party_transfer: thirdParty.transfer,
                by_initiator: byInitiator
            },
            items: pick
        };
    }

    function sendResourceSummary() {
        const pv = getPageViewId();
        if (!pv) return;

        const summary = summarizeResources("topn");
        send({
            occurred_at: new Date().toISOString(),
            event_type: "resource_summary",
            page_view_id: pv,
            path: location.pathname + location.search,
            resources: summary
        });
    }

    function sendResourceDebug() {
        const pv = getPageViewId();
        if (!pv) return;

        const dbg = summarizeResources("error_debug");
        send({
            occurred_at: new Date().toISOString(),
            event_type: "resource_debug",
            page_view_id: pv,
            path: location.pathname + location.search,
            resources: dbg
        });
    }

    function run() {
        const nav = navMetrics();
        if (!nav) return;

        const paint = firstPaintMetrics();

        const event = {
            occurred_at: new Date().toISOString(),
            event_type: 'page_nav',
            page_view_id: getPageViewId(),
            path: location.pathname + location.search,
            referrer: document.referrer || null,
            ua_raw: navigator.userAgent,
            lang: navigator.language || null,
            ttfb_ms_cli: nav.ttfb_ms,
            duration_ms_cli: nav.total_ms,
            dcl_ms_cli: nav.dcl_ms,
            load_ms_cli: nav.load_ms,
            interactive_ms_cli: nav.interactive_ms,
            fp_ms: paint.fp_ms,
            fcp_ms: paint.fcp_ms,
            bytes_in_cli: nav.bytes_in,
        };

        send(event);
    }

    window.addEventListener('load', function () {
        setTimeout(run, 0);
        setTimeout(sendResourceSummary, 1200);
    });

    window.__telemetrySendResourceSummary = sendResourceSummary;
    window.__telemetrySendResourceDebug = sendResourceDebug;
})();

/* ============================================================
   UX ACTIVITY TRACKING WITH HEARTBEAT
   ============================================================ */
(function () {
    if (window.__telemetryUxTrackingInitialized) return;
    window.__telemetryUxTrackingInitialized = true;

    const IDLE_THRESHOLD = 15000;
    const HEARTBEAT_INTERVAL = 60000;

    let visibleStart = Date.now();
    let visibleMs = 0;

    let activeStart = Date.now();
    let activeMs = 0;

    let lastActivity = Date.now();
    let isActive = true;

    let backgroundStart = null;
    let backgroundMs = 0;

    let sentFinal = false;
    let hbTimer = null;

    function getPageViewId() {
        if (typeof window.__EVE_GET_CURRENT_PAGE_VIEW_ID === 'function') {
            return window.__EVE_GET_CURRENT_PAGE_VIEW_ID();
        }
        const meta = document.querySelector('meta[name="eve-page-view-id"]');
        return meta?.getAttribute("content") || null;
    }

    function send(event) {
        const url = '/ajax/telemetry/metrics';
        const blob = new Blob([JSON.stringify(event)], { type: 'application/json' });

        if (navigator.sendBeacon) {
            navigator.sendBeacon(url, blob);
        } else {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(event),
                keepalive: true
            }).catch(() => {});
        }
    }

    function flush(now) {
        if (document.visibilityState === "visible") {
            visibleMs += now - visibleStart;
            visibleStart = now;

            if (isActive) {
                activeMs += now - activeStart;
                activeStart = now;
            }

            if (backgroundStart != null) {
                backgroundMs += now - backgroundStart;
                backgroundStart = null;
            }
        } else {
            if (backgroundStart == null) backgroundStart = now;
            backgroundMs += now - backgroundStart;
            backgroundStart = now;
            isActive = false;
        }
    }

    function buildPayload(eventType) {
        const pvId = getPageViewId();
        if (!pvId) return null;

        const now = Date.now();
        flush(now);

        const v = visibleMs;
        const a = activeMs;
        const bg = backgroundMs;
        const idle = Math.max(0, v - a);

        return {
            occurred_at: new Date().toISOString(),
            event_type: eventType,
            page_view_id: pvId,
            path: location.pathname + location.search,
            visible_ms: Math.round(v),
            active_ms: Math.round(a),
            idle_ms: Math.round(idle),
            background_ms: Math.round(bg),
        };
    }

    document.addEventListener("visibilitychange", () => {
        const now = Date.now();

        if (document.visibilityState === "hidden") {
            flush(now);
            return;
        }

        visibleStart = now;
        lastActivity = now;
        isActive = true;
        activeStart = now;
        flush(now);
    });

    ["mousemove","mousedown","keydown","scroll","touchstart"]
        .forEach(evt => window.addEventListener(evt, () => {
            const now = Date.now();
            lastActivity = now;

            if (document.visibilityState !== "visible") return;

            if (!isActive) {
                isActive = true;
                activeStart = now;
            }
        }, { passive: true }));

    setInterval(() => {
        const now = Date.now();

        if (
            document.visibilityState === "visible" &&
            isActive &&
            now - lastActivity > IDLE_THRESHOLD
        ) {
            activeMs += now - activeStart;
            isActive = false;
        }
    }, 5000);

    function sendHeartbeat() {
        const payload = buildPayload('page_view_heartbeat');
        if (payload) send(payload);
    }

    function startHeartbeat() {
        if (hbTimer) return;
        sendHeartbeat();
        hbTimer = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
    }

    function stopHeartbeat() {
        if (!hbTimer) return;
        clearInterval(hbTimer);
        hbTimer = null;
    }

    function resetTrackingState() {
        const now = Date.now();
        visibleStart = now;
        visibleMs = 0;
        activeStart = now;
        activeMs = 0;
        lastActivity = now;
        isActive = true;
        backgroundStart = null;
        backgroundMs = 0;
        sentFinal = false;
    }

    startHeartbeat();

    function sendFinal() {
        if (sentFinal) return;
        sentFinal = true;

        stopHeartbeat();

        const now = Date.now();
        flush(now);

        const payload = buildPayload('page_view_metrics');
        if (payload) send(payload);
    }

    window.addEventListener('eve:before-pageview-change', function () {
        sendFinal();
        resetTrackingState();
        startHeartbeat();
    });

    window.addEventListener("pagehide", sendFinal);
    window.addEventListener("beforeunload", sendFinal);
})();